module.exports = __webpack_public_path__ + "static/img/home-icon-ppdb-done.798ac5cb.svg";